import * as React from "react";
import { Box } from "@mui/material";
export default function LoafCard({ children, sx }) {
  return (
    <Box
      sx={{
        position: "relative",
        p: 3,
        borderRadius: 4,
        overflow: "hidden",
        backdropFilter: "blur(14px)",
        background:
          "linear-gradient(145deg, rgba(255,255,255,0.10), rgba(255,255,255,0.04))",
        border: "1px solid rgba(255,255,255,0.12)",
        transition: "all 0.3s ease",
        width: "100%",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 12px 40px rgba(0, 0, 0, 0.15)",
        },
        "&:before": {
          content: '""',
          position: "absolute",
          inset: 0,
          borderRadius: 4,
          padding: "2px",
          backgroundImage:
            "linear-gradient(135deg, rgba(215, 109, 135, 1), rgba(121,209,195,.8))",
          WebkitMask:
            "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
          WebkitMaskComposite: "xor",
          maskComposite: "exclude",
          pointerEvents: "none",
          filter: "blur(0.5px)",
        },
        ...sx,
      }}
    >
      <Box sx={{ width: "100%", height: "100%" }}>{children}</Box>
    </Box>
  );
}
